// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"9":"cd113108","120":"6a3cfa2b","375":"a6593a2a","462":"b8b4ff40","560":"456e6919","771":"c569ff41","778":"8368d47c","816":"fb777e0e"}[chunkId] + ".js";
};